export const militaryData = {
    ranks: [
        "ไม่ระบุ", "นาย", "นาง", "นางสาว", "จ.ต.", "จ.ต.หญิง", "จ.ท.", "จ.ท.หญิง", 
        "จ.อ.", "จ.อ.หญิง", "พ.อ.ต.", "พ.อ.ต.หญิง", "พ.อ.ท.", "พ.อ.ท.หญิง", "พ.อ.อ.", 
        "พ.อ.อ.หญิง", "ร.ต.", "ว่าที่ ร.ต.", "ร.ต.หญิง", "ว่าที่ ร.ต.หญิง", "ร.ท.", 
        "ว่าที่ ร.ท.", "ร.ท.หญิง", "ว่าที่ ร.ท.หญิง", "ร.อ.", "ว่าที่ ร.อ.", "ร.อ.หญิง", 
        "ว่าที่ ร.อ.หญิง", "น.ต.", "ว่าที่ น.ต.", "น.ต.หญิง", "ว่าที่ น.ต.หญิง", 
        "น.ท.", "ว่าที่ น.ท.", "น.ท.หญิง", "ว่าที่ น.ท.หญิง", "น.อ.", "ว่าที่ น.อ.", 
        "น.อ.หญิง", "ว่าที่ น.อ.หญิง", "พล.อ.ต.", "พล.อ.ต.หญิง", "พล.อ.ท.", 
        "พล.อ.ท.หญิง", "พล.อ.อ.", "พล.อ.อ.หญิง"
      ],
      corps: [
        "ถร.", "ชอ.", "ชย.", "กง.", "สบ.", "ส.", "พธ.", "สพ.", "พ.", "ขส.", "วศ.", 
        "อย.", "สห.", "พด.", "ดย.", "ผท.", "อต.", "ตห."
      ],
      groups: [
        "ผู้ทำการในอากาศ", "ยุทธการ", "นักบิน", "วิทยาศาสตร์", "อุตุนิยมวิทยา", 
        "ควบคุมการปฏิบัติทางอากาศ", "นิรภัย", "สารสนเทศและสงครามอิเล็กทรอนิกส์", 
        "สื่อสารอิเล็กทรอนิกส์", "สรรพาวุธ", "ช่างอากาศ", "ส่งกำลังบำรุง", "ช่างพาหนะ", 
        "ช่างโยธา", "แผนที่", "ขนส่ง", "พลาธิการ", "พัสดุ", "การเงิน", "ปลัดบัญชี", 
        "ตรวจสอบภายใน", "สารบรรณ", "ลาดตระเวนทางอากาศ", "กำลังพล", "สวัสดิการ", 
        "การศึกษาและการฝึก", "ดุริยางค์", "สารวัตร", "อากาศโยธิน", 
        "กิจการพลเรือนและประชาสัมพันธ์", "อนุศาสนาจารย์", "บริการแพทย์", "พยาบาล", 
        "การข่าวกรอง", "พระธรรมนูญ", "ผู้ชำนาญการแพทย์เฉพาะอย่าง", "เภสัชกร", "แพทย์", 
        "ทันตแพทย์", "ผู้บังคับอากาศยานไร้คนขับ", "ปฏิบัติการทางอวกาศ", "ไม่ระบุจำพวก"
      ],
      companies: [
        "ศบพ.", "ศฮพ.", "ศกอ.", "สพร.ทอ.", "สคม.ทอ.", "สลก.ทอ.", "สบ.ทอ.", "กพ.ทอ.", 
        "ขว.ทอ.", "ยก.ทอ.", "กบ.ทอ.", "กร.ทอ.", "ทสส.ทอ.", "สปช.ทอ.", "กง.ทอ.", 
        "จร.ทอ.", "สตน.ทอ.", "สนภ.ทอ.", "สธน.ทอ.", "ศซบ.ทอ.", "สบน.ทอ.", "คปอ.ทอ.", 
        "อย.", "รร.การบิน", "บน.1", "บน.2", "บน.3", "บน.4", "บน.5", "บน.7", "บน.6", 
        "บน.23", "บน.21", "บน.41", "บน.46", "บน.56", "ศปอว.ทอ.", "พธ.ทอ.", "ชอ.", 
        "สอ.ทอ.", "สพ.ทอ.", "พอ.", "ขส.ทอ.", "ชย.ทอ.", "ศซว.ทอ.", "ยศ.ทอ.", 
        "รร.นนก.", "ศวอ.ทอ.", "สก.ทอ.", "สน.ผบ.ดม.", "สวบ.ทอ."
      ]
};